import { createSelector } from '@reduxjs/toolkit';
import { JobState } from 'ducks/job/slices';
import { normalizeJobParameters } from 'ducks/job/utils';
import { RootState } from 'store';

const jobSlice = (state: RootState) => state.job;

export const selectJobParams = createSelector([jobSlice], (state) => normalizeJobParameters(state));
export const selectJob = createSelector([jobSlice], (state): JobState => state);
